import { render, staticRenderFns } from "./CardTeacherName.vue?vue&type=template&id=a298a18e&scoped=true"
import script from "./CardTeacherName.vue?vue&type=script&lang=js"
export * from "./CardTeacherName.vue?vue&type=script&lang=js"
import style0 from "./CardTeacherName.vue?vue&type=style&index=0&id=a298a18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a298a18e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
